import { useState } from "react";

function IntermediateOptionsTradingModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "1. Recap of Options Fundamentals",
      content: [
        "Quick review of essential options terms: Calls, Puts, Strike Price, Expiration Date, Premium.",
        "Importance of the Greeks (Delta, Gamma, Theta, Vega, Rho) in options trading.",
        "Understanding the concept of intrinsic value and time value.",
      ],
    },
    {
      title: "2. Options Pricing and Implied Volatility",
      content: [
        "Detailed explanation of Implied Volatility (IV) and its impact on options pricing.",
        "How changes in IV affect options premiums (Volatility Crush and Volatility Expansion).",
        "Using the Volatility Index (VIX) to predict market sentiment.",
        "Strategies for trading during periods of high and low volatility.",
      ],
    },
    {
      title: "3. Vertical Spreads: Enhancing Returns with Defined Risk",
      content: [
        "Bull Call Spread: Using call spreads to profit from a moderately bullish outlook.",
        "Bear Put Spread: Profiting from a moderately bearish market with limited risk.",
        "How to choose strike prices and expirations for vertical spreads.",
        "Risk/reward analysis and breakeven points for each strategy.",
      ],
    },
    {
      title: "4. Horizontal (Calendar) Spreads",
      content: [
        "Long Calendar Spread: Capturing time decay with options of different expiration dates.",
        "Benefits of trading calendar spreads in low-volatility environments.",
        "Adjusting calendar spreads when the market moves unexpectedly.",
        "Case study: Using calendar spreads around earnings announcements.",
      ],
    },
    {
      title: "5. Diagonal Spreads: Combining Price and Volatility Moves",
      content: [
        "Bullish Diagonal Spread: Combining elements of vertical and horizontal spreads for an edge.",
        "Bearish Diagonal Spread: Leveraging put diagonals for a bearish outlook.",
        "Best practices for managing diagonals in volatile markets.",
        "Real-world examples of profitable diagonal spread setups.",
      ],
    },
    {
      title: "6. Straddles and Strangles: Trading Volatility Without Directional Bias",
      content: [
        "Long Straddle: Profiting from significant price movement in either direction.",
        "Example: Buying an at-the-money call and put with the same expiration.",
        "Long Strangle: A cost-effective way to trade volatility with out-of-the-money options.",
        "Example: Buying an out-of-the-money call and put.",
        "Risk management: Setting stop-loss and profit targets for straddle and strangle trades.",
        "Ideal market conditions for implementing straddles and strangles.",
      ],
    },
    {
      title: "7. Iron Condor: Income Strategy for Range-Bound Markets",
      content: [
        "Understanding the Iron Condor: Selling both a call and put spread to collect premium.",
        "How to set up an iron condor with optimal strike prices and expirations.",
        "Adjustments for iron condors when the market breaks out of the expected range.",
        "Risk management techniques for iron condor positions.",
      ],
    },
    {
      title: "8. Butterfly Spreads: Low-Risk Strategies for Stable Markets",
      content: [
        "Long Call Butterfly: Capitalizing on minimal price movement with low upfront cost.",
        "Example: Buying one lower strike call, selling two middle strike calls, and buying one higher strike call.",
        "Long Put Butterfly: Bearish alternative using puts for range-bound markets.",
        "Adjusting butterfly spreads to maximize profits or minimize losses.",
        "Breakeven points and risk/reward analysis for butterfly trades.",
      ],
    },
    {
      title: "9. Options for Hedging and Risk Management",
      content: [
        "Using Protective Puts to safeguard your stock portfolio.",
        "How to set up a Collar Strategy to lock in profits while limiting downside risk.",
        "Hedging with options in uncertain market conditions.",
        "Real-life examples of using options to hedge against market downturns.",
      ],
    },
    {
      title: "10. Analyzing Option Chains and Open Interest",
      content: [
        "How to read and interpret option chains for better decision-making.",
        "The significance of Open Interest (OI) and Volume in predicting market moves.",
        "Identifying support and resistance levels using options data.",
        "Spotting unusual options activity for potential trading opportunities.",
      ],
    },
    {
      title: "11. Executing and Managing Trades",
      content: [
        "Best practices for executing multi-leg options strategies.",
        "The importance of liquidity and selecting the right options contracts.",
        "Adjusting positions when trades move against you.",
        "Tips for managing emotions and staying disciplined in options trading.",
      ],
    },
  ];

  return (
    <div className="container-fluid">
      <div className="container py-5">
        <h1 className="text-center mb-5">Intermediate Options Trading</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div key={index} className="col-12 col-md-5 mb-3">
              {/* Module Header */}
              <div
                className="p-3 d-flex justify-content-between align-items-center"
                style={{
                  background: "#e9ecef",
                  border: "1px solid #ced4da",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: "18px",
                    transform: openModule === index ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Module Content */}
              {openModule === index && (
                <div
                  className="p-3 mt-2"
                  style={{
                    background: "#ffffff",
                    border: "1px solid #ced4da",
                    borderRadius: "5px",
                  }}
                >
                  {module.content.map((item, i) => (
                    <p key={i} style={{ fontSize: "14px", margin: "5px 0" }}>
                      ➤ {item}
                    </p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default IntermediateOptionsTradingModule;
